'use strict'

const toastDelay = process.env.VUE_APP_BOOTSTRAP_TOAST_DELAY

const makeToast = (component, body, variant, delay) => {
  component.$bvToast.toast(body, {
    // noCloseButton: true,
    title: body,
    variant: variant,
    autoHideDelay: delay || toastDelay,
    solid: true,
    toaster: process.env.VUE_APP_BOOTSTRAP_TOASTER
  })
}

export default {
  makeToast
}
